import React from 'react';
import {CSVLink} from "react-csv";
import {PDFDownload} from 'components/PDFComposer';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {PDFPreviewModal} from "components/PDFComposer";
import {Button} from "reactstrap";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";

const {StatelessModal} = Framework.Elements;

const headers = [
	{label: "Serial #", key: "serial"},
	{label: "Product", key: "product"},
	{label: "Location", key: "location"},
	{label: "Stock", key: "stock"},
	{label: "Status", key: "status"},
	{label: "Scanned", key: "scanned"},
	{label: "Removed", key: "removed"},
	{label: "Inventory Notes", key: "notes"},
];

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'Inventory Count',
		url: '/products/inventories',
		icon: 'list-ul',
	},
];

export default class Inventory extends Framework.Components.View {

	constructor(props) {
		super(props);

		Object.assign(this.state, {
			showPDFPreviewModal: false,
			downloadPDF: false,
			rows: [],
		});

		const baseFileName = `inventory_${new Date().toLocaleDateString().replace(/\//g, '-')}`;
		this.pdfFileName = `${baseFileName}.pdf`;
		this.csvFileName = `${baseFileName}.csv`;
	}

	handleTogglePDFViewer = () => {
		this.setState({showPDFPreviewModal: !this.state.showPDFPreviewModal});
	}

	handleTogglePDFDownload = () => {
		this.setState({downloadPDF: !this.state.downloadPDF})
	}

	handlePrint = () => {
		window.print();
	}

	removeSoldFirearms = async() => {
		//call the backend to remove sold firearms for the given inventory
		let inventoryItemModel = new API.BuildClass(Types.Inventories_Items._name, 'POST_SOLD');
		inventoryItemModel.parent = this.props.match.params.id;
		await inventoryItemModel.submit(null, 'POST_SOLD');
		//TODO: for extra flare, tell them how many got removed cause they were sold?
		//refresh the table
		this.refreshPage();
	}

	/**
	 * @param {Array.<Inventories_Items_Object>} data
	 */
	formatCSVData = (data) => {

		let rows = [];
		for (let i = 0, len = data.length; i < len; i++) {

			let status_name = '';
			switch (true) {
				case (data[i].removed === true): {
					status_name = 'Removed';
					break;
				}
				case (data[i].status === 2): {
					status_name = 'Not In Stock';
					break;
				}
				case (data[i].notes != null && data[i].notes.length > 0): {
					status_name = 'Has Inventory Note';
					break;
				}
				case (data[i].scanned === 0): {
					status_name = 'Not Scanned Yet';
					break;
				}
				case (data[i].scanned > 1): {
					status_name = 'Duplicate Scan';
					break;
				}
				case (data[i].scanned === 1): {
					status_name = 'Scanned';
					break;
				}
				default: {
					status_name = '';
					break;
				}
			}
			rows.push({
				serial: data[i].products.serial_number,
				product: data[i].products.type + ' | ' + (data[i].products.manufacturer ? data[i].products.manufacturers.name : data[i].products.manufacturer_other) + ' | ' + data[i].products.model,
				location: data[i].locations.name,
				stock: data[i].product_statuses.name,
				status: status_name,
				scanned: data[i].scanned ? 'Scanned' : '',
				removed: data[i].removed ? 'Removed' : '',
				notes: data[i].notes
			});
		}

		this.setState({rows});
	};

	handleTogglePrintReport = () => {
		this.setState({
			showPDFPreviewModal: true,
		})
	}

	render() {
		let {showPDFPreviewModal, downloadPDF, rows} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.props.id,
				url: `/products/inventories/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button onClick={this.removeSoldFirearms} size="sm" color="success">
						<i className="fa fa-usd"/>&nbsp;&nbsp;Remove Sold Firearms
					</Button>
					<Button onClick={this.handlePrint} size="sm" color="primary">
						<i className="fa fa-print"/>&nbsp;&nbsp;Print Current View
					</Button>
					<Button onClick={this.handleTogglePrintReport} size="sm" color="primary">
						<i className="fa fa-print"/>&nbsp;&nbsp;Print Report
					</Button>
					<Button onClick={this.handleTogglePDFDownload} size="sm" color="primary">
						<i className="fa fa-download"/>&nbsp;&nbsp;Download Report
						{downloadPDF ?
							<PDFDownload
								rows={rows}
								headers={headers}
								fileName={this.pdfFileName}
								onClose={this.handleTogglePDFDownload}
							/> : null}
					</Button>
					<CSVLink
						data={rows}
						headers={headers}
						filename={this.csvFileName}
						className="btn btn-primary btn-sm"
						target="_blank"
						color="primary"
					>
						<i className="fa fa-download"/>&nbsp;&nbsp;Download CSV
					</CSVLink>
				</Framework.Components.PageBar>

				<div className="form-group">
					<div className="row">
						<div className="col-4">
							<Objects.Inventory
								id={this.props.match.params.id}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								updateName={this.updateName}
								baseUrl={this.props.baseUrl}
							/>
							<h4 className="section-title">Inventory Guide</h4>
							<div>
								When inventory is started all products / firearms that are In Stock at the selected Location get added to inventory as
								<mark style={{backgroundColor: '#c6c6c6'}}>Not Scanned Yet</mark>.
								<br/><br/>
								Scanned products will be marked off on the inventory report as <mark
								style={{backgroundColor: '#1bbc9b', color: '#ffffff'}}>Found</mark>.
								<br/><br/>
								If a the same product barcode is scanned twice the system flags it as a <mark
								style={{backgroundColor: '#dfba49', color: '#ffffff'}}>Duplicate Scan</mark>.
								<br/><br/>
								To record a note about an item click on the <mark style={{backgroundColor: '#89c4f4', color: '#ffffff'}}>Inventory
								Notes</mark> field, all notes are printed on the inventory report.
								<br/><br/>
								If a product is scanned that is not In Stock or that should be at another Location the system will flag the item in
								the inventory report <mark style={{backgroundColor: '#EF5350', color: '#ffffff'}}>Wrong Location / Not In
								Stock</mark>.
								<br/><br/>
								Once you are finished you can "Complete" the inventory report and all remaining products that have not yet been
								scanned will be flagged as <mark style={{backgroundColor: '#EF5350', color: '#ffffff'}}>Not Found</mark>.
							</div>
						</div>
						<div className="col-8">
							<Collections.Inventory
								parent={this.props.match.params.id}
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								updateName={this.updateName}
								formatCSVData={this.formatCSVData}
								scannedCodeAlt={this.props.scannedCode}
							/>
						</div>
					</div>
				</div>

				<StatelessModal
					title="PDF Preview"
					isOpen={showPDFPreviewModal}
					onToggle={this.handleTogglePDFViewer}
				>
					<PDFPreviewModal {...this.state} headers={headers} fileName={this.pdfFileName}/>
				</StatelessModal>
			</div>
		)
	}
};